import uniqid from 'uniqid'
export const jobsData = [
    {
        id: uniqid(),
        type: 'company',
        company: 'Centro de Diseño Digital',
        startDate: '2012-02',
        endDate: '2015-09',
        title: 'Profesor',
        isEditing: false,
    },
    {
        id: uniqid(),
        type: 'company',
        company: 'funval',
        startDate: '2010-01',
        endDate: '2013-08',
        title: 'Diseñador',
        isEditing: false,
    },
]
